import { render, staticRenderFns } from "./_base-popper.vue?vue&type=template&id=eb6c4080&"
import script from "./_base-popper.vue?vue&type=script&lang=js&"
export * from "./_base-popper.vue?vue&type=script&lang=js&"
import style0 from "./_base-popper.vue?vue&type=style&index=0&id=eb6c4080&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports